import GtagState from '../types/GtagState'

export const state: GtagState = {
  registered: false,
  source: null,
  last_source: null,
  unsubscribers: []
};
